/**
 * A function that waits until a condition passes (or a max timeout) before resolving
 * @param conditionFn - a function that when returns true resolves the wait Promise
 * @param maxWaitTime - the maximum amount of time to wait until
 */
export default function waitUntil(conditionFn: () => boolean, maxWaitTime: number = 2000): Promise<void> {
  const start = Date.now()

  const checkCondition = resolve => {
    if (conditionFn()) {
      return resolve()
    }

    const elapsed = Date.now() - start
    if (elapsed > maxWaitTime) {
      return resolve()
    }

    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => checkCondition(resolve), {
        timeout: 1000
      })
    } else {
      setTimeout(() => checkCondition(resolve), 50)
    }
  }

  return new Promise(checkCondition)
}
